import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Text} from '@chakra-ui/react'
import {FormattedMessage, useIntl} from 'react-intl'
import {useAddToCartModalContext} from '../../../hooks/use-add-to-cart-modal'
import {useShopperBasketsMutationHelper} from '@salesforce/commerce-sdk-react'
import {useToast} from '../../../hooks/use-toast'
import {API_ERROR_MESSAGE} from '../../../constants'
import {noop} from '../../../utils/utils'
import {CheckIcon} from '../../icons'
import Link from '@salesforce/retail-react-app/app/components/link'

const AddWarrantyToCartButton = ({
    product,
    parentProductId,
    callback = noop,
    isDisabled = false,
}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const {data: modalData} = useAddToCartModalContext()
    const showToast = useToast()
    const intl = useIntl()

    const handleAddToCart = async (e) => {
        e.stopPropagation()
        setIsLoading(true)

        try {
            const productItem = {
                productId: product.productId,
                quantity: 1,
                c_isWarranty: true,
                c_parentProductId: parentProductId || modalData?.itemsAdded?.[0]?.product?.id,
            }

            const result = await addItemToNewOrExistingBasket([productItem])

            if (result) {
                setIsSuccess(true)
                setTimeout(() => {
                    callback(product)
                }, 1500)
            }
        } catch (error) {
            console.error('Error adding warranty to cart:', error)
            showToast({
                title: intl.formatMessage(API_ERROR_MESSAGE),
                status: 'error',
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            {isSuccess ? (
                <Button
                    data-testid="add-warranty-to-cart-button-success"
                    w="full"
                    variant="inverted-pressed"
                    isDisabled={true}
                >
                    <Flex alignItems="center" gap={2}>
                        <CheckIcon />
                        <Text>
                            <FormattedMessage
                                id="global.warranty-added-to-cart"
                                defaultMessage="Garanzia aggiunta"
                            />
                        </Text>
                    </Flex>
                </Button>
            ) : (
                <Button
                    data-testid="add-warranty-to-cart-button"
                    w="full"
                    as={Link}
                    to="/cart"
                    onClick={handleAddToCart}
                    isLoading={isLoading}
                    isDisabled={isDisabled || isLoading}
                    variant="primary"
                >
                    <FormattedMessage
                        id="global.add-warranty-to-cart"
                        defaultMessage="Aggiungi garanzia"
                    />
                </Button>
            )}
        </>
    )
}

AddWarrantyToCartButton.propTypes = {
    product: PropTypes.shape({
        productId: PropTypes.string.isRequired,
    }).isRequired,
    parentProductId: PropTypes.string,
    callback: PropTypes.func,
    isDisabled: PropTypes.bool,
}

export default AddWarrantyToCartButton
